// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2026 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { FEATURE_PAPER_SESSIONS } from '@/constants/features.js';

export const routing = [
    {
        path: [config.routes.paperSessions.list],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_PAPER_SESSIONS),
            getPermissionsGuard([
                { resource: 'portal.paper-scans', scopes: ['view'] },
                { resource: 'portal.paperbased-session', scopes: ['view'] }
            ])
        ]),
        controller: () => import('./controllers/paperSessions')
    },
    {
        path: [config.routes.paperSessions.details],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_PAPER_SESSIONS),
            getPermissionsGuard([{ resource: 'portal.paper-scans', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/paperSessionsDetails')
    }
];
